(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/redbeemedia/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/redbeemedia/assets/javascripts/prescript.js');
'use strict';

var svs = svs || {};

svs.components = svs.components || {};
svs.components.redbee_video_player = svs.components.redbee_video_player || {};


 })(window);